import AddPhoneInfoComponent from './AddPhoneInfoContainer';

export default AddPhoneInfoComponent;